import React from 'react';
import NFTModal from './NFTModal';
import { wattImage } from '../assets';

const WATT_MARKETPLACES = [
  {
    name: "SentX",
    url: "https://sentx.io/nft-marketplace/watt",
    priceKey: "sentx",
    displayNameKey: "sentxMarket"
  },
  {
    name: "Kabila",
    url: "https://market.kabila.app/collections/3934850/items",
    priceKey: "kabila",
    displayNameKey: "kabilaMarket"
  }
];

const WattModal = ({ isOpen, onClose }) => (
  <NFTModal
    isOpen={isOpen}
    onClose={onClose}
    collectionKey="watt"
    image={wattImage}
    titleKey="modals.wattTitle"
    descKey="modals.wattDesc"
    benefitsKey="modals.wattBenefits"
    benefitsDescKey="modals.wattBenefitsDesc"
    benefitsIcon="⚡"
    marketplaces={WATT_MARKETPLACES}
  />
);

export default WattModal;
